export enum AlertSeverityLevel {
  None = 'None',
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}
